import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { CommonState, CommonTypes } from './types';

const INITIAL_STATE: CommonState = {
    data: {
        floatingCourseActionsBarConfiguration: {
            previousButtonTitle: '',
            nextButtonTitle: '',
            saveButtonTitle: '',
            currentStep: 1,
            totalSteps: 1,
            onSave: () => {},
            saveDisabled: true,
            onPrevious: () => {},
            onNext: () => {},
            previewDisabled: true,
            nextDisabled: true,
            blockUi: false,
        },
    },
    modal: {},
};

const reducer: Reducer<CommonState> = (state: CommonState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case CommonTypes.SET_FLOATING_COURSE_ACTIONS_CONFIGURATION:
            return {
                ...state,
                data: {
                    ...state.data,
                    floatingCourseActionsBarConfiguration: { ...state.data.floatingCourseActionsBarConfiguration, ...action.payload },
                },
            };
        case CommonTypes.OPEN_MODAL:
            return {
                ...state,
                modal: {
                    ...state.modal,
                    [action.payload.id]: {
                        id: action.payload.id,
                        isVisible: true,
                        layoutModal: action.payload.layoutModal,
                        isCloseAllowed: action.payload.isCloseAllowed,
                    },
                },
            };
        case CommonTypes.CLOSE_MODAL:
            const modal = { ...state.modal };
            delete modal[action.payload];
            return { ...state, modal };
        case CommonTypes.CLEAR_MODAL:
            return { ...state, modal: {} };
        default:
            return state;
    }
};

export default reducer;
